var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-stand-dark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stand-dark",
    clipPath: "url(#clip-stand-dark)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(-194.538 -173.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M174.15,222.53a3.086,3.086,0,0,1,3.1-3.077H326.229a3.086,3.086,0,0,1,3.095,3.077v11.259a3.087,3.087,0,0,1-3.095,3.078H177.246a3.088,3.088,0,0,1-3.1-3.078Z",
    transform: "translate(42.801 60.076)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M186.487,225.846a6.173,6.173,0,0,1,6.191-6.156H304.519a6.174,6.174,0,0,1,6.191,6.156V279.9a6.174,6.174,0,0,1-6.191,6.156H192.678a6.173,6.173,0,0,1-6.191-6.156Z",
    transform: "translate(45.941 60.136)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M184.452,149.784a9.273,9.273,0,0,1,9.063-7.231H309.031a9.275,9.275,0,0,1,9.065,7.231l8.253,34.982A9.246,9.246,0,0,1,317.286,196H185.262a9.246,9.246,0,0,1-9.065-11.236Z",
    transform: "translate(43.265 40.509)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M193.889,182.434a3.086,3.086,0,0,1,3.095-3.078h3.095a3.088,3.088,0,0,1,3.1,3.078V311.7a3.087,3.087,0,0,1-3.1,3.078h-3.095a3.086,3.086,0,0,1-3.095-3.078Z",
    transform: "translate(47.824 49.873)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M270.709,182.434a3.086,3.086,0,0,1,3.095-3.078H276.9a3.087,3.087,0,0,1,3.1,3.078V311.7a3.087,3.087,0,0,1-3.1,3.078H273.8a3.086,3.086,0,0,1-3.095-3.078Z",
    transform: "translate(67.371 49.873)",
    fill: "#2d3040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStand);
export default __webpack_public_path__ + "static/media/stand.403ff84c664017a20eaa25498738a500.svg";
export { ForwardRef as ReactComponent };